import React, { useEffect, useState, useRef } from 'react';
import { Helmet } from 'react-helmet-async';

// ============================================================
// PLAYLIST CONFIG — Change this to swap playlists in the future
// ============================================================
const PLAYLIST = {
  title: "80's Synthpop Odyssey",
  spotifyId: '4pD28L6HYJ8ctgZdKHCxDJ',
  spotifyUrl: 'https://open.spotify.com/playlist/4pD28L6HYJ8ctgZdKHCxDJ',
  artwork: '/api/og-playlist-image',
  ogImage: 'https://syntetikworld.com/api/og-playlist-image',
};

const CONTENT = {
  es: {
    headline: 'El Soundtrack de una Generación',
    subheadline: 'Descubre Synthpop, New Wave y clásicos de los 80s que definieron una era.',
    cta: 'Escuchar en Spotify',
    redirecting: 'Abriendo Spotify...',
    fallback: 'Play en Spotify',
    sectionTitle: 'Más que un artista. Un hogar para los amantes del Synthpop.',
    cards: [
      { title: 'Playlist Destacada', desc: "80's Synthpop Odyssey", icon: 'playlist', link: null },
      { title: 'Último Lanzamiento', desc: 'Take My Hand', icon: 'release', link: '/' },
      { title: 'Videos Musicales', desc: 'Visuales cinematográficos', icon: 'video', link: '/#visuals' },
      { title: 'Próximamente', desc: 'Nuevas playlists en camino', icon: 'future', link: null },
    ],
    ogDesc: "Sumérgete en un viaje por el Synthpop de los 80s. New Wave, Retro Pop y sonidos que definieron una era.",
  },
  en: {
    headline: 'The Soundtrack of a Generation',
    subheadline: 'Discover timeless Synthpop, New Wave and 80s classics.',
    cta: 'Listen on Spotify',
    redirecting: 'Opening Spotify...',
    fallback: 'Play on Spotify',
    sectionTitle: 'More than an artist. A home for Synthpop lovers.',
    cards: [
      { title: 'Featured Playlist', desc: "80's Synthpop Odyssey", icon: 'playlist', link: null },
      { title: 'Latest Release', desc: 'Take My Hand', icon: 'release', link: '/' },
      { title: 'Music Videos', desc: 'Cinematic visuals', icon: 'video', link: '/#visuals' },
      { title: 'Coming Soon', desc: 'New playlists on the way', icon: 'future', link: null },
    ],
    ogDesc: "Dive into an 80s Synthpop journey. New Wave, Retro Pop and sounds that defined an era.",
  },
  pt: {
    headline: 'A Trilha Sonora de uma Geração',
    subheadline: 'Descubra Synthpop, New Wave e clássicos dos anos 80.',
    cta: 'Ouvir no Spotify',
    redirecting: 'Abrindo Spotify...',
    fallback: 'Play no Spotify',
    sectionTitle: 'Mais que um artista. Um lar para os amantes do Synthpop.',
    cards: [
      { title: 'Playlist em Destaque', desc: "80's Synthpop Odyssey", icon: 'playlist', link: null },
      { title: 'Último Lançamento', desc: 'Take My Hand', icon: 'release', link: '/' },
      { title: 'Vídeos Musicais', desc: 'Visuais cinematográficos', icon: 'video', link: '/#visuals' },
      { title: 'Em Breve', desc: 'Novas playlists a caminho', icon: 'future', link: null },
    ],
    ogDesc: "Mergulhe em uma viagem pelo Synthpop dos anos 80.",
  },
  fr: {
    headline: "La Bande-Son d'une Génération",
    subheadline: 'Découvrez le Synthpop, la New Wave et les classiques des années 80.',
    cta: 'Écouter sur Spotify',
    redirecting: 'Ouverture de Spotify...',
    fallback: 'Play sur Spotify',
    sectionTitle: "Plus qu'un artiste. Un foyer pour les amoureux du Synthpop.",
    cards: [
      { title: 'Playlist Vedette', desc: "80's Synthpop Odyssey", icon: 'playlist', link: null },
      { title: 'Dernière Sortie', desc: 'Take My Hand', icon: 'release', link: '/' },
      { title: 'Clips Vidéo', desc: 'Visuels cinématographiques', icon: 'video', link: '/#visuals' },
      { title: 'Bientôt', desc: 'Nouvelles playlists en route', icon: 'future', link: null },
    ],
    ogDesc: "Plongez dans un voyage Synthpop des années 80.",
  },
  de: {
    headline: 'Der Soundtrack einer Generation',
    subheadline: 'Entdecke zeitlosen Synthpop, New Wave und 80er Klassiker.',
    cta: 'Auf Spotify anhören',
    redirecting: 'Spotify wird geöffnet...',
    fallback: 'Play auf Spotify',
    sectionTitle: 'Mehr als ein Künstler. Ein Zuhause für Synthpop-Liebhaber.',
    cards: [
      { title: 'Featured Playlist', desc: "80's Synthpop Odyssey", icon: 'playlist', link: null },
      { title: 'Neueste Veröffentlichung', desc: 'Take My Hand', icon: 'release', link: '/' },
      { title: 'Musikvideos', desc: 'Filmische Visuals', icon: 'video', link: '/#visuals' },
      { title: 'Demnächst', desc: 'Neue Playlists unterwegs', icon: 'future', link: null },
    ],
    ogDesc: "Tauche ein in eine 80er Synthpop-Reise.",
  },
  it: {
    headline: 'La Colonna Sonora di una Generazione',
    subheadline: 'Scopri Synthpop, New Wave e classici degli anni 80.',
    cta: 'Ascolta su Spotify',
    redirecting: 'Apertura di Spotify...',
    fallback: 'Play su Spotify',
    sectionTitle: "Più di un artista. Una casa per gli amanti del Synthpop.",
    cards: [
      { title: 'Playlist in Evidenza', desc: "80's Synthpop Odyssey", icon: 'playlist', link: null },
      { title: 'Ultima Uscita', desc: 'Take My Hand', icon: 'release', link: '/' },
      { title: 'Video Musicali', desc: 'Visual cinematografici', icon: 'video', link: '/#visuals' },
      { title: 'Prossimamente', desc: 'Nuove playlist in arrivo', icon: 'future', link: null },
    ],
    ogDesc: "Immergiti in un viaggio nel Synthpop degli anni 80.",
  },
};

const CardIcon = ({ type }) => {
  const icons = {
    playlist: (
      <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 9l10.5-3m0 6.553v3.75a2.25 2.25 0 01-1.632 2.163l-1.32.377a1.803 1.803 0 11-.99-3.467l2.31-.66a2.25 2.25 0 001.632-2.163zm0 0V2.25L9 5.25v10.303m0 0v3.75a2.25 2.25 0 01-1.632 2.163l-1.32.377a1.803 1.803 0 01-.99-3.467l2.31-.66A2.25 2.25 0 009 15.553z" />
      </svg>
    ),
    release: (
      <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M15.91 11.672a.375.375 0 010 .656l-5.603 3.113a.375.375 0 01-.557-.328V8.887c0-.286.307-.466.557-.327l5.603 3.112z" />
      </svg>
    ),
    video: (
      <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
        <path strokeLinecap="round" d="M15.75 10.5l4.72-4.72a.75.75 0 011.28.53v11.38a.75.75 0 01-1.28.53l-4.72-4.72M4.5 18.75h9a2.25 2.25 0 002.25-2.25v-9a2.25 2.25 0 00-2.25-2.25h-9A2.25 2.25 0 002.25 7.5v9a2.25 2.25 0 002.25 2.25z" />
      </svg>
    ),
    future: (
      <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
  };
  return icons[type] || null;
};

const PlaylistLanding = () => {
  const [lang, setLang] = useState('en');
  const [redirectState, setRedirectState] = useState('waiting'); // waiting | redirecting | failed
  const [heroVisible, setHeroVisible] = useState(true);
  const [cardsVisible, setCardsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const langParam = urlParams.get('lang');
    if (langParam && CONTENT[langParam]) {
      setLang(langParam);
    } else {
      setLang('en');
    }

    // Fade in hero
    requestAnimationFrame(() => setHeroVisible(true));

    // Auto-redirect after 3s (gives time to see content + FB Pixel fires)
    const timer = setTimeout(() => {
      setRedirectState('redirecting');
      try {
        window.location.href = PLAYLIST.spotifyUrl;
        // If still here after 4s, show fallback
        setTimeout(() => setRedirectState('failed'), 4000);
      } catch {
        setRedirectState('failed');
      }
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  // Intersection observer for cards
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setCardsVisible(true); },
      { threshold: 0.15 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  const t = CONTENT[lang];

  const openSpotify = () => {
    window.location.href = PLAYLIST.spotifyUrl;
  };

  return (
    <>
      <Helmet>
        <title>{PLAYLIST.title} — SYNTETIK World</title>
        <meta name="description" content={t.ogDesc} />
        <meta property="og:type" content="music.playlist" />
        <meta property="og:title" content={`${PLAYLIST.title} — SYNTETIK World`} />
        <meta property="og:description" content={t.ogDesc} />
        <meta property="og:image" content={PLAYLIST.ogImage} />
        <meta property="og:url" content={`https://syntetikworld.com/playlist?lang=${lang}`} />
        <meta property="og:site_name" content="SYNTETIK World" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={`${PLAYLIST.title} — SYNTETIK World`} />
        <meta name="twitter:description" content={t.ogDesc} />
        <meta name="twitter:image" content={PLAYLIST.ogImage} />
        <link rel="canonical" href={`https://syntetikworld.com/playlist?lang=${lang}`} />
      </Helmet>

      <div className="min-h-screen bg-[#080808] text-white overflow-x-hidden" data-testid="playlist-landing">

        {/* ===== HEADER ===== */}
        <header className="fixed top-0 left-0 right-0 z-50 px-6 py-4 flex items-center justify-between bg-gradient-to-b from-black/80 to-transparent backdrop-blur-sm">
          <a href="/" className="text-white/70 hover:text-white transition-colors text-xs tracking-[0.35em] font-light" data-testid="brand-link">
            SYNTETIK WORLD
          </a>
          <a
            href={PLAYLIST.spotifyUrl}
            className="text-[11px] tracking-[0.15em] text-white/40 hover:text-[#1DB954] transition-colors font-light hidden sm:block"
          >
            OPEN IN SPOTIFY
          </a>
        </header>

        {/* ===== HERO SECTION ===== */}
        <section className="relative min-h-screen flex items-center justify-center px-6" data-testid="playlist-hero">
          {/* Background */}
          <div className="absolute inset-0 overflow-hidden">
            <div
              className="absolute inset-0 bg-cover bg-center transition-transform duration-[3000ms]"
              style={{
                backgroundImage: `url(${PLAYLIST.artwork})`,
                filter: 'blur(60px) brightness(0.12) saturate(1.4)',
                transform: heroVisible ? 'scale(1.15)' : 'scale(1.3)',
              }}
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-transparent to-[#080808]" />
            <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,transparent_30%,#080808_75%)]" />
          </div>

          {/* Content */}
          <div className={`relative z-10 flex flex-col items-center text-center max-w-2xl mx-auto transition-all duration-1000 ${heroVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}>

            {/* Artwork */}
            <div className="w-52 h-52 sm:w-64 sm:h-64 rounded-lg overflow-hidden shadow-[0_30px_80px_rgba(0,0,0,0.7)] mb-10 ring-1 ring-white/5">
              <img
                src={PLAYLIST.artwork}
                alt={PLAYLIST.title}
                className="w-full h-full object-cover"
                loading="eager"
                data-testid="playlist-artwork"
              />
            </div>

            {/* Playlist label */}
            <span className="text-[11px] tracking-[0.3em] text-white/30 font-light mb-4 uppercase">
              Spotify Playlist
            </span>

            {/* Title */}
            <h1
              className="text-3xl sm:text-4xl md:text-5xl font-light tracking-tight leading-[1.15] mb-4"
              style={{ fontFamily: "'Inter', -apple-system, system-ui, sans-serif" }}
              data-testid="playlist-headline"
            >
              {t.headline}
            </h1>

            {/* Subtitle */}
            <p className="text-sm sm:text-base text-white/45 font-light max-w-md leading-relaxed mb-10">
              {t.subheadline}
            </p>

            {/* CTA Button — always visible, pulses on fallback */}
            <button
              onClick={openSpotify}
              data-testid="playlist-cta"
              className={`group flex items-center gap-3 bg-[#1DB954] hover:bg-[#1ed760] text-black font-semibold px-10 py-4 rounded-full transition-all duration-300 hover:scale-[1.04] shadow-[0_6px_30px_rgba(29,185,84,0.25)] hover:shadow-[0_8px_40px_rgba(29,185,84,0.35)] mb-4 ${redirectState === 'failed' ? 'animate-pulse ring-2 ring-[#1DB954]/40 scale-[1.03]' : ''}`}
            >
              {/* Spotify icon */}
              <svg className="w-6 h-6 transition-transform duration-300 group-hover:scale-110" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z"/>
              </svg>
              {/* Play icon — shows on fallback for extra clarity */}
              {redirectState === 'failed' && (
                <svg className="w-5 h-5 -ml-1" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M8 5v14l11-7z"/>
                </svg>
              )}
              {redirectState === 'failed' ? t.fallback : t.cta}
            </button>

            {/* Redirect status */}
            <div className="h-6 flex items-center gap-2" data-testid="redirect-status">
              {redirectState === 'waiting' && (
                <span className="text-white/20 text-[11px] tracking-wider">
                  ⏳
                </span>
              )}
              {redirectState === 'redirecting' && (
                <span className="text-white/30 text-xs tracking-wider flex items-center gap-2 animate-pulse">
                  <span className="w-1.5 h-1.5 bg-[#1DB954] rounded-full"></span>
                  {t.redirecting}
                </span>
              )}
              {redirectState === 'failed' && (
                <span className="text-white/30 text-[11px] tracking-wider">
                  ↑ {t.fallback}
                </span>
              )}
            </div>

            {/* Scroll hint */}
            <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 opacity-30">
              <div className="w-px h-8 bg-gradient-to-b from-transparent to-white/40"></div>
            </div>
          </div>
        </section>

        {/* ===== EXPLORE SECTION ===== */}
        <section
          ref={sectionRef}
          className="relative py-24 px-6"
          data-testid="explore-section"
        >
          <div className="max-w-4xl mx-auto">
            {/* Section title */}
            <div className={`text-center mb-16 transition-all duration-1000 delay-100 ${cardsVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
              <h2 className="text-lg sm:text-xl font-light text-white/70 tracking-wide leading-relaxed">
                {t.sectionTitle}
              </h2>
              <div className="w-12 h-px bg-white/10 mx-auto mt-6"></div>
            </div>

            {/* Cards grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
              {t.cards.map((card, i) => {
                const CardWrapper = card.link ? 'a' : 'div';
                const wrapperProps = card.link ? { href: card.link } : {};
                return (
                  <CardWrapper
                    key={i}
                    {...wrapperProps}
                    className={`group p-6 rounded-xl border border-white/[0.06] bg-white/[0.02] hover:bg-white/[0.05] hover:border-white/[0.12] transition-all duration-500 cursor-pointer ${cardsVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
                    style={{ transitionDelay: `${200 + i * 100}ms` }}
                    data-testid={`card-${card.icon}`}
                  >
                    <div className="text-white/25 group-hover:text-white/50 transition-colors duration-300 mb-4">
                      <CardIcon type={card.icon} />
                    </div>
                    <h3 className="text-sm font-medium text-white/70 group-hover:text-white/90 transition-colors mb-1 tracking-wide">
                      {card.title}
                    </h3>
                    <p className="text-xs text-white/30 font-light">{card.desc}</p>
                  </CardWrapper>
                );
              })}
            </div>
          </div>
        </section>

        {/* ===== FOOTER ===== */}
        <footer className="py-12 px-6 text-center border-t border-white/[0.04]">
          <a href="/" className="text-[10px] tracking-[0.4em] text-white/15 hover:text-white/30 transition-colors font-light">
            SYNTETIK WORLD
          </a>
        </footer>
      </div>
    </>
  );
};

export default PlaylistLanding;
